import { Spinner } from "component-library";

import "./FullScreenSpinner.scss";

export const FullScreenSpinner = () => {
  return (
    <div className="c-full-screen-spinner">
      <Spinner />
    </div>
  );
};
